import type { SVGProps } from "react";

/** Flag of Poland, drawn in a 4:3 box shared by every flag in this folder. */
export function FlagPl(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 60 45" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="60" height="22.5" fill="#ffffff" />
      <rect y="22.5" width="60" height="22.5" fill="#dc143c" />
    </svg>
  );
}
